import { inject, Injectable } from '@angular/core';
import { MenuItemBuilder } from '../builders/menu-item.builder';
import { RouteProviderService } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class MenuItemBuilderFactory {
  private readonly provider = inject(RouteProviderService);

  public create(): MenuItemBuilder {
    return new MenuItemBuilder(this.provider);
  }
}
